import customAxios from "./axiosConfig";

const QuotationService = {
  retrieve: function (quotation_id, params) {
    const api_url = '/api/v2/quotations/' + quotation_id + '/'
    return customAxios.get(api_url, { params: params });
  }
}

export default QuotationService;
